import { render, staticRenderFns } from "./LatestDetail.vue?vue&type=template&id=4bafac33&scoped=true"
import script from "./LatestDetail.vue?vue&type=script&lang=js"
export * from "./LatestDetail.vue?vue&type=script&lang=js"
import style0 from "./LatestDetail.vue?vue&type=style&index=0&id=4bafac33&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bafac33",
  null
  
)

export default component.exports